import { createFeatureSelector } from '@ngrx/store';

export const memberSignupPolicyState = createFeatureSelector<OLO.State, OLO.State.MemberSignupPolicy>('memberSignupPolicy');
